<template>
  <div>
    <loading :active.sync="isLoading"
    :can-cancel="true"
    color="#5bad2b"
    :is-full-page="true"></loading>
    <div class="container maincontent">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="tab-content">
              <div class="active tab-pane" id="activity">
                <div class="row postdata">
                  <div style="margin-top:20px">
                    <div class="nav">
                      <div class="box-header">
                        <h3 class="box-title pageTitle fw-600">Profiles</h3>
                      </div>
                      <!-- <hr class="myline"> -->
                      <hr style="margin-top:2px; margin-bottom:6px" />
                      <div class="row postArea" v-if="postData != null">
                        <div class="col-md-5 p-1">
                          <div class="candidateArea">
                            <div class="Orgimage1">
                              <img class="round" v-if="postData.org_logo !='' && postData.org_logo !=null" :src="`${postData.org_logo}`">
                              <img class="round" v-if="postData.org_logo =='' || postData.org_logo ==null" src="../assets/img/default.png">
                              <!-- <img v-if="x.profile_picture !='' && x.profile_picture !=null" :src="`${x.profile_picture}`">
                                    <img v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == null" src="../assets/img/default.png">
                              <img v-if="x.profile_picture =='' || x.profile_picture ==null && x.gender == 'Female'" src="../assets/img/female_default.png">-->
                              <!-- <img
                                class="round"
                                src="../assets/img/default.png"
                              /> -->
                            </div>
                            <div class=" candidateDetails col-md-12">
                              <span class="canName">{{postData.job_tittle}}</span>
                              <br />
                              <span>{{postData.post_unique_id}}</span>
                              <br />
                              <!-- <span>9677696198</span> -->
                              <span class="overflow" :title="postData.primaryskillnames">
                                <span class="skill-lable">Skills :</span>
                                {{postData.primaryskillnames}}
                              </span>
                            </div>
                            <!-- <div class="col-md-11 p-1">
                              <div class="mt-2"></div>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7 p-1">
                          <div class="row">
                            <div class="col-md-3 p-1 countcard" style="text-align:center" >
                              <a class="" @click="status=''; score=''; sit=''; selectedSt=''; candidateList()">
                                <div class="countStyle">{{postData.profile_count}}</div>
                                <div class="countSpecificationStyle">
                                  Profiles
                                </div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit=''; selectedSt='';status=='Scheduled' ? status='' : status='Scheduled'; candidateList()">
                                <div class="countStyle" :style="status=='Scheduled'?'font-weight:bold; color:#5bad2b':''">{{postData.scheduled_count}}</div>
                                <div class="countSpecificationStyle" :style="status=='Scheduled'?'font-weight:bold; color:#5bad2b':''">
                                  Scheduled
                                </div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; status=''; selectedSt='';sit=='>6'? sit='' : sit='>6'; candidateList()">
                                <div class="countStyle" :style="sit=='>6'?'font-weight:bold; color:#5bad2b':''">{{postData.sit_count}}</div>
                                <div class="countSpecificationStyle" :style="sit=='>6'?'font-weight:bold; color:#5bad2b':''">SIT>6</div>
                              </a>
                            </div>
                            <div class="col-md-3 p-1" style="text-align:center">
                              <a @click="score=''; sit='';status=''; selectedSt=='Yes'? selectedSt='' : selectedSt='Yes'; candidateList()">
                                <div class="countStyle" :style="selectedSt=='Yes'?'font-weight:bold; color:#5bad2b':''">{{postData.selected_count}}</div>
                                <div class="countSpecificationStyle" :style="selectedSt=='Yes'?'font-weight:bold; color:#5bad2b':''">
                                  Selected
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="myIcons">
                        <div class="icon1" @click="selectInterviewer()" v-if="postData != null">
                          <i class="fa fa-user-o" aria-hidden="true"></i>
                          <span class="badge badge-light">{{postData.selected_interviewers_count}}</span>
                          <br />
                          <span class="iconName">Select Interviewers</span>
                        </div>
                        <div
                          class="icon2"
                          data-toggle="modal"
                          data-target="#uploadResume" @click="resumefiles = []"
                        >
                          <i class="fa fa-cloud-upload" aria-hidden="true"></i>
                          <br />
                          <span class="iconName">Upload Resume</span>
                        </div>
                      </div>
                      <div class="col-md-3 filterBoxBorder">
                        <!-- <div class="card">
                          <div>Filter By</div>
                        </div> -->
                        <div class="box box-primary">
                          <div class="box-header with-border filterbyClass">
                            <h3 class="box-title">Filter By</h3>
                            <div class="box-tools pull-right">
                              <button
                                type="button"
                                @click="clearFilter"
                                class="btn btn-box-tool btncolorClass"
                              >
                                <b>Clear</b>
                              </button>
                            </div>
                          </div>
                          <div class="box-body">
                            <ul class="filterTopclass">
                              <li class="filterListclass">
                                <div>
                                  <a href="#" class="">Status</a>
                                </div>
                                <div class="filterDivclass form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      style="height:30px"
                                      placeholder="Select Status"
                                      v-model="status"
                                      @change="candidateList"
                                    >
                                      <option value="" selected
                                        >Select Status</option
                                      >
                                      <option value="New">New</option>
                                      <option value="Schedule Request Pending">Schedule Request Pending</option>
                                      <option value="Scheduled"
                                        >Scheduled</option
                                      >
                                      <option value="Open">Open</option>
                                      <option value="Declined">Declined</option>
                                      <option value="Auto-Declined">Auto-Declined</option>
                                      <option value="Reschedule Request pending">Reschedule Request pending</option>
                                      <option value="Re-Scheduled">Re-Scheduled</option>
                                      <option value="Completed">Completed</option>
                                      <option value="Incomplete">Incomplete</option>
                                      <option value="Selected">Selected</option>
                                      <option value="Rejected">Rejected</option>
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li>
                              <li class="filterListclass">
                                <div>
                                  <a href="#" class="">Score</a>
                                  <!-- <span class="pull-right"><i class="" v-bind:class="{ 'fa fa-angle-up' : activeFilter == 'score', 'fa fa-angle-down' : activeFilter != 'score' }"></i></span> -->
                                </div>
                                <div class="filterDivclass  form-group">
                                  <div class="form-select">
                                    <select
                                      class="form-control"
                                      placeholder="Select Score"
                                      style="height:30px"
                                      v-model="score"
                                      @change="candidateList"
                                    >
                                      <option value="" selected
                                        >Select Score</option
                                      >
                                      <option value="0">0</option>
                                      <option
                                        :value="n"
                                        v-for="n in 10"
                                        :key="n"
                                        >{{ n }}</option
                                      >
                                    </select>
                                    <span class="select-icon"
                                      ><i class="fa fa-chevron-down"></i
                                    ></span>
                                  </div>
                                </div>
                              </li>
                              <li class="filterListclass">
                                <div>
                                  <a href="#" class="">Date</a>
                                  <!-- <span class="pull-right"><i class="" v-bind:class="{ 'fa fa-angle-up' : activeFilter == 'date', 'fa fa-angle-down' : activeFilter != 'date' }"></i></span> -->
                                </div>
                                <div class="filterDivclass">
                                  <div>
                                    <datetime
                                      v-model="fromdate"
                                      format="dd-MMM-yyyy"
                                      type="date"
                                      placeholder="Select From Date"
                                      @keyup="candidateList"
                                    >
                                    </datetime>
                                    <br />
                                    <datetime
                                      v-model="todate"
                                      format="dd-MMM-yyyy"
                                      type="date"
                                      placeholder="Select To Date"
                                      @keyup="candidateList"
                                    >
                                    </datetime>
                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-9" >
                        <div >
                        <div class="filterdata">
                          <div class="searchinput">
                            <input
                              v-model="postsearch"
                              type="text"
                              class=" search-text"
                              placeholder="Search.."
                              @keyup="candidateList"
                            />
                            <button><i class="fa fa-search"></i></button>
                          </div>
                          <!-- <div style="width:50%;" class="pull-right filterby">
                            <div class="form-group">
                              <div
                                class="form-select pull-right"
                                style="width: 50%;;height:30%"
                              >
                                <select
                                  @change="postList()"
                                  class="form-control input-sm"
                                >
                                  <option value="7">Last 7 days</option>
                                  <option value="30">Last 30 days</option>
                                </select>
                                <span class="select-icon">
                                  <i class="fa fa-chevron-down"></i>
                                </span>
                              </div>
                            </div>
                            <span class="pull-right mt-5 ml-1">Sort by</span>
                          </div> -->
                        </div>
                        <div class="text-center">
                          <div class="box-body">
                            <ul style="list-style:none" class="profileClass">
                              <div v-if="candidateListing < 1" class="text-muted tc" style="margin-top: 20%;">No data found</div>
                              <!-- <ul style="list-style:none" v-for="post in mypostList" :key="post._id"> -->
                              <li v-for="(mydata, indexx) in candidateListing" :key="indexx">
                                <div class="postArea1 col-mod-12" :class="{ 'warningBorder': (mydata.candidate_email === '' || mydata.candidate_email === null || mydata.candidate_email === undefined ), 'dangerBorder': (mydata.candidate_mobile_number === '' || mydata.candidate_mobile_number === null || mydata.candidate_mobile_number === undefined ) }">
                                  <div class="candidateArea col-mod-6" style="text-align:start">
                                    <div class="Orgimage">
                                      <!-- <img class="round" v-if="post.profile_picture !='' && post.profile_picture !=null" :src="`${post.profile_picture}`" alt=""> -->
                                      <a :href="mydata.resume">
                                      <img
                                      class="resume"
                                        src="../assets/img/resume2.png"
                                        alt
                                      /></a>
                                    </div>
                                    <div class="abc" >
                                      <a class="candidateDetails overflow" @click="editCandidateFn(mydata)">
                                        <span :title="mydata.candidate_name" class="canName" v-if="mydata.candidate_name != ''">{{mydata.candidate_name}}</span>
                                        <span class="canName" v-else>-</span>
                                        <br />
                                        <span :title="mydata.candidate_email" v-if="mydata.candidate_email != ''">{{mydata.candidate_email}}</span>
                                        <span v-else>&nbsp;</span>
                                        <br />
                                        <span :title="mydata.candidate_mobile_number">{{mydata.candidate_mobile_number}}</span>
                                      </a>
                                    </div>
                                  </div>
                                  <div class="status col-mod-3">
                                    <div class="statusName">
                                      <span style="color:black" v-if="mydata.status=='Schedule Request' && mydata.schedule_date == null">New</span>
                                      <span v-else-if="mydata.status=='Schedule Request' && mydata.schedule_date != null"><a style="color:#5bad2b" @click="showPanels(mydata._id)">Schedule Request Pending</a></span>
                                      <span v-else-if="mydata.status=='Open' && mydata.reschedule_by==null && mydata.feedback_status!='Completed'"><a style="color:black"  @click="showShedule1(mydata._id,mydata.user_id)">Scheduled</a></span>
                                      <span style="color:red" v-else-if="mydata.status=='Cancelled'">Open</span>
                                      <span v-else-if="mydata.status=='Declined'" @click="openInfo(mydata)"><a style="color:red">Declined</a></span>
                                      <span style="color:red" v-else-if="mydata.status=='Auto-Declined'">Auto-Declined</span>
                                      <span style="color:#5bad2b" v-else-if="mydata.status=='Accepted'">Accepted</span>
                                      <span style="color:#5bad2b" v-else-if="mydata.status=='reschedule' && mydata.reschedule_by=='organization' && mydata.interview_status!='Incomplete'">Re-Schedule Request pending</span>
                                      <span v-else-if="mydata.status =='reschedule' && mydata.reschedule_by=='interviewer'" @click="showShedule1(mydata._id,mydata.user_id)"><a style="color:#5bad2b">Reschedule Requested</a></span>
                                      <span v-else-if="mydata.status=='Open' && mydata.reschedule_by!=null"><a style="color:black"  @click="showShedule1(mydata._id,mydata.user_id)">Re-Scheduled</a></span>
                                      <span v-else-if="mydata.feedback_status=='Pending'" @click="showResult(mydata._id, mydata.user_id)" ><a style="color:#5bad2b" >Completed</a></span>
                                      <span v-else-if="mydata.status != 'Open' && mydata.interview_status=='Incomplete'" @click="showResult(mydata._id, mydata.user_id)" ><a style="color:#5bad2b">Incomplete</a></span>
                                      <span v-else-if="mydata.feedback_status=='Completed' && mydata.interview_status!='Incomplete'" @click="showResult(mydata._id, mydata.user_id)">
                                        <a style="color:#5bad2b">SIT {{mydata.sit_score != null ? mydata.sit_score : ''}}</a>
                                      </span>
                                    </div>
                                    <div v-if="mydata.feedback_status=='Pending'">Feedback Pending</div>
                                  </div>
                                  <div class="availability1 col-mod-3">
                                    <div v-if="mydata.reschedule_by!=null && mydata.restart_datetime != 'Invalid date' && mydata.restart_datetime != null" class="validity">
                                    <!-- <div class="validity"> -->
                                      <div style="font-weight:bold">
                                        {{getDate(mydata.restartdatetime_utc)}}
                                        <!-- {{mydata.restart_datetime | formatDate}} -->
                                      </div>
                                      <div>{{getTime(mydata.restartdatetime_utc)}} - {{getTime(mydata.reenddatetime_utc)}}</div>
                                    </div>
                                    <div class="validity" v-else-if="mydata.status !='reschedule' && mydata.startdatetime_utc != 'Invalid date'">
                                      <div style="font-weight:bold">
                                        {{getDate(mydata.startdatetime_utc)}}
                                        <!-- {{mydata.start_datetime | formatDate}} -->
                                      </div>
                                      <div>{{getTime(mydata.startdatetime_utc)}} - {{getTime(mydata.enddatetime_utc)}}</div>
                                    </div>
                                    <div class="validity" v-else-if="mydata.startdatetime_utc != 'Invalid date'">
                                      <div style="font-weight:bold">
                                        {{getDate(mydata.startdatetime_utc)}}
                                        <!-- {{mydata.start_datetime | formatDate}} -->
                                      </div>
                                      <div>{{getTime(mydata.startdatetime_utc)}} - {{getTime(mydata.enddatetime_utc)}}</div>
                                    </div>
                                    <div>
                                      <div class="buttonStyle">
                                        <!-- <button :disabled="checkingdate(mydata.startdatetime_utc, mydata.enddatetime_utc) == 'no'"  class="btn connectbtn btn-sm pull-right" >
                                          Connect
                                        </button> -->
                                        <span v-if="mydata.status == 'Schedule Request' && mydata.schedule_date == null">
                                          <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                            Set Availability
                                          </a>
                                        </span>
                                        <span v-if="mydata.status=='Schedule Request' && mydata.schedule_date != null && Number(postData.selected_interviewers_count) >= 1">
                                          <a style="color:blue" @click="setSchedule(mydata)">
                                            Schedule
                                          </a>
                                        </span>
                                        <span v-if="mydata.status == 'Reschedule Requested' && mydata.req_new_time !='interviewer'">
                                          <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                            Set Availability
                                          </a>
                                        </span>
                                        <span v-if="mydata.status == 'Reschedule Requested' && mydata.reschedule_by ==null && mydata.req_new_time =='interviewer'">
                                          <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                            Set Availability
                                          </a>
                                        </span>
                                         <span v-if="mydata.status == 'Declined'  && Number(postData.selected_interviewers_count) >= 1" @click="setSchedule(mydata)">
                                          <a class="direct-chat-timestamp" style="color:blue; padding:0 6px; border-radius:12px;"> Schedule </a>
                                          <!-- Declined -->
                                        </span>
                                        <span v-if="mydata.status=='Cancelled' || mydata.status == 'Declined'">
                                          <span>
                                            <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                              Set Availability
                                            </a>
                                          </span>
                                          <!-- <a class="direct-chat-timestamp  mt-2" style="color:red; background-color:#F5F5F5; padding:0 6px; border-radius:12px;">Cancelled</a> -->
                                        </span>
                                        <span v-if="mydata.status == 'Auto-Declined'" @click="openInfo(mydata)">
                                          <a class="direct-chat-timestamp" style="color:red; padding:0 6px; border-radius:12px;"> Auto-Declined </a>
                                        </span>
                                        <span v-if="mydata.status == 'Expired'">
                                          <a class="direct-chat-timestamp" style="color:#E74E4E;padding:0 6px;border-radius:12px;"> Expired </a>
                                        </span>
                                        <span v-if="mydata.status == 'Accepted'" @click="openInfo(mydata)">
                                          <a class="direct-chat-timestamp " style="color:rgb(96 171 47); padding:0 6px; border-radius:12px;"> Accepted </a>
                                        </span>
                                        <span v-if="mydata.status == 'Open' || mydata.status == 'Accepted'">
                                          <span @click="showReason1(mydata.user_id,mydata._id,1)" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i> Cancel </span>
                                          <!-- showReason(mydata.user_id,mydata._id) -->
                                        </span>
                                        <span v-if="mydata.status == 'Open' && mydata.reschedule_by ==null && mydata.req_new_time !='interviewer'">
                                          <a style="color:blue" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata, 'reschedule')">
                                            Re-Schedule
                                          </a>
                                        </span>
                                        <span v-if="mydata.status == 'Open'">
                                          <button :disabled="checkingdate(mydata.startdatetime_utc, mydata.enddatetime_utc) == 'no'"  style="color:blue" @click="connect(mydata.meeting_id,mydata._id,mydata.user_id, mydata)" class="btn connectbtn btn-sm pull-right">
                                            Connect
                                          </button>
                                        </span>
                                      </div>
                                      <div class="buttonStyle">
                                        <span v-if="mydata.status == 'reschedule' && mydata.reschedule_by=='interviewer' && mydata.interview_status!='Incomplete'">
                                          <span @click="showReason1(mydata.user_id,mydata._id,1, 're')" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i>
                                            Decline
                                          </span>
                                        </span>
                                        <span v-if="mydata.status == 'reschedule' && mydata.reschedule_by=='organization' && mydata.interview_status!='Incomplete'">
                                          <span @click="showReason1(mydata.user_id,mydata._id,1, 're')" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i>
                                            Cancel
                                          </span>
                                        </span>
                                        <span v-if="mydata.status=='reschedule'  && mydata.reschedule_by=='interviewer' && mydata.interview_status!='Incomplete' && Number(postData.selected_interviewers_count) >= 1">
                                          <a style="color:blue" @click="setSchedule(mydata)">
                                            Schedule
                                          </a>
                                        </span>
                                        <span v-if="mydata.status == 'reschedule' && mydata.reschedule_by =='interviewer'">
                                          <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                            Set Availability
                                          </a>
                                        </span>
                                        <span v-if="mydata.status =='Reschedule Requested' && mydata.req_new_time !='interviewer'" @click="showReason1(mydata.user_id,mydata._id,1)" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i>
                                          Decline
                                        </span>
                                        <span v-if="mydata.status =='Reschedule Requested' && mydata.reschedule_by !=null && mydata.req_new_time =='interviewer'" @click="showReason1(mydata.user_id,mydata._id,2)" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i>
                                          Decline
                                        </span>
                                        <span v-if="mydata.status == 'Reschedule Requested' && mydata.reschedule_by ==null && mydata.req_new_time =='interviewer'" @click="showReason1(mydata.user_id,mydata._id,3)" class="direct-chat-timestamp" style="color:red;cursor:pointer;"><i class="fa fa-times" aria-hidden="true"></i>
                                          Decline
                                        </span>
                                        <span v-if="mydata.feedback_status=='Completed' && mydata.candidate_selected == 'No'" class="direct-chat-timestamp" style="color:red;cursor:pointer;">
                                          Rejected
                                        </span>
                                        <span class="direct-chat-timestamp" style="color:red;cursor:pointer;" v-if="mydata.interview_status!='Incomplete' && mydata.feedback_status=='Completed' && mydata.candidate_selected == ''" @click="selectModal(mydata._id, 'No')"><i class="fa fa-times" aria-hidden="true"></i>
                                          Reject
                                        </span>
                                        <span v-if="mydata.feedback_status=='Completed' && mydata.candidate_selected == 'Yes'" class="direct-chat-timestamp" style="color:green;cursor:pointer;">
                                          Selected
                                        </span>
                                        <span class="direct-chat-timestamp" style="color:green;cursor:pointer;" v-if="mydata.interview_status!='Incomplete' && mydata.feedback_status=='Completed' && mydata.candidate_selected == ''" @click="selectModal(mydata._id, 'Yes')"><i class="fa fa-check" aria-hidden="true"></i>
                                          Select
                                        </span>
                                        <!-- <span v-if="mydata.status != 'Schedule Request' && mydata.feedback_status!='Pending' && mydata.status != 'Open' && mydata.interview_status=='Incomplete'" >
                                          <a style="color:#5bad2b" data-toggle="modal" data-target="#setAvailability" @click="setAvailabilityDataSet(mydata)">
                                            Set Availability
                                          </a>
                                        </span>
                                        <span v-if="mydata.status != 'Schedule Request' && mydata.feedback_status!='Pending' && mydata.status != 'Open' && mydata.interview_status=='Incomplete' && Number(postData.selected_interviewers_count) >= 1">
                                          <a style="color:blue" @click="setSchedule(mydata)">
                                            Schedule
                                          </a>
                                        </span> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </li>
                            </ul>
                            <!-- <div class="row paginationClass" style="background-color: white;" v-if="candidateListing.length > 0">
                              <jw-pagination :items="exampleItems" @changePage="onChangePage" :pageSize="25"></jw-pagination>
                            </div> -->
                          </div>
                        </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="tab-pane" id="timeline">
<div class="skillset">
</div>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- modal for uploadResume -->
      <div
        class="modal fade"
        id="uploadResume"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel">
                Upload Candidate Resume
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </h4>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <div class="custom-file-upload">
                  <div v-if="resumefiles.length < 1" class="show-doc-empty">
                    Select the File
                  </div>
                  <div class="show-doc" v-if="resumefiles.length > 0">
                    <span
                      class="doc-file pull-left"
                      v-for="(x, index) in resumefiles.slice(0, 2)"
                      :key="index"
                    >
                      <span class="doc-name">{{ x.name }}</span>
                      <i
                        @click="removeUploading(index)"
                        class="fa fa-times"
                        style="color: #ccc;"
                        aria-hidden="true"
                      ></i>
                    </span>
                  </div>
                  <label for="file1">
                    <i class="uil uil-upload" aria-hidden="true"></i> Upload
                  </label>
                  <input
                    @change="fileUpload1($event)"
                    style="visibility: hidden;"
                    type="file"
                    id="file1"
                    name="myfiles[]"
                    multiple
                  />
                </div>
                <p style="color: red;margin: 3px 0 10px; font-size: 12px;">{{errormsg}}</p>
                <p style="color: #aeaaaa;margin: 3px 0 10px;">
                  Supported format (.pdf, .docx), Size (Max 3MB)
                </p>
              </div>
              <div v-if="resumefiles.length > 0">
                <div v-for="(y, ind) in resumefiles" :key="ind">
                  <div class="row">
                    <div>
                      <span class="doc-name col-md-5 p-1">{{ y.name }}</span>
                      <i
                        @click="removeUploading(ind)"
                        class="fa fa-times"
                        style="color: #ccc;"
                        aria-hidden="true"
                      ></i>
                    </div>
                  </div>
                  <br />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <!-- <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button type="button" class="btn btn-primary">Save changes</button>-->
              <button
                :disabled="resumefiles.length < 1"
                type="button"
                @click="UploadCandidateResume()"
                style="margin-right: 10px;"
                class="btn btn-success"
              >
                Submit
              </button>
              <button
                data-dismiss="modal"
                type="button"
                class="btn btn-default"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Modal for Set Availability---->
      <div
        class="modal fade"
        id="setAvailability"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content AvailabilityPopup">
            <div class="modal-header">
              <h4 class="modal-title" id="exampleModalLabel">
                <span v-if="setAvailabilityType=='reschedule'">Reschedule</span>
                <span v-else>Set Availability</span>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true" class="modalClose">&times;</span>
                </button>
              </h4>
            </div>
            <div class="modal-body">
              <div class="setavailability">
                <div class="form-group" v-if="setAvailabilityType=='reschedule'">
                  <div class="form-select">
                    <select id="reason" v-model="reScheduleReason" class="form-control is-valid">
                      <option value=''>Select the Reason *</option>
                      <option v-for="x in reasonList" v-bind:value="x" :key="x.value">{{x.value}}</option>
                    </select>
                    <span class="select-icon"><i class="fa fa-chevron-down"></i></span>
                  </div><br>
                </div>
                <div v-if="setAvailabilityType=='reschedule'">
                  <b-form-textarea v-model="reScheduleComments" class="textarea" rows="5" placeholder="Enter Comments*"></b-form-textarea><br>
                </div>
                <datetime
                  v-model="availability"
                  format="dd-MMM-yyyy hh:mm a"
                  :min-datetime="minDatetime1"
                  :minute-step="30"
                  type="datetime"
                  :value-zone="timezone"
                  :zone="timezone"
                  use12-hour
                  placeholder="Select Date *"
                >
                </datetime>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
              <button :disabled="disableSetAvailabilityButton" type="button" @click="setAvailability()" class="btn btn-success">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal overlay fade in" id="myModal1">
      <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
        <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12" style="text-align: center;">
                  <p style="font-size: 20px;font-weight: 400;">{{infoName}}</p><br>
                  <button class="btn btn-success" @click="closeViolated()">Ok</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal overlay fade in" id="selectModalShow">
      <div class="modal-dialog" style="margin-top:115px !important;width: 450px !important;">
        <div class="modal-content" style="width: 450px;margin-left: auto;margin-right: auto;border-radius: 7px;">
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12" style="text-align: center;">
                  <p style="font-size: 20px;font-weight: 400;" v-if="selected=='Yes'">Are you sure want to select this candidate?</p>
                  <p style="font-size: 20px;font-weight: 400;" v-if="selected=='No'">Are you sure want to reject this candidate?</p><br>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-success" @click="selectCandidate()">Yes</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <div class="modal overlay fade in" id="modal-default" style="display: block;" v-show="showInterviewersListModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content AvailabilityPopup">
          <div class="modal-header">
            <h3 class="modal-title">
              <span>Invited Interviewers</span>
              <button
                type="button"
                class="close"
                @click="onClose()"
              >
                <span aria-hidden="true" class="modalClose">&times;</span>
              </button>
            </h3>
          </div>
          <div class="modal-body" style="padding:0px">
            <div class="row" >
              <div class="col-md-12 " style="padding:17px">
                <div class="col-md-12">
                  <p style="font-size: 18px;font-weight: 400; text-align: start;" v-if="interviewersListErrorMsg!=''">{{interviewersListErrorMsg}}</p>
                  <div class="col-sm-12" v-else>
                    <div class="table-responsive text-nowrap">
                      <table id="example1" class="table table-striped" role="grid" aria-describedby="example1_info" style="font-size: 12px;">
                        <thead>
                          <tr role="row" style="text-align: center">
                            <th rowspan="1" colspan="1">ID</th>
                            <th rowspan="1" colspan="1">Interviewer Name</th>
                            <th rowspan="1" colspan="1">Phone</th>
                            <th rowspan="1" colspan="1">Declined Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr role="row" class="odd" v-for="(x, ind) in interviewersList" :key="ind">
                            <td>{{x.user_id}}</td>
                            <td>{{x.user_name}}</td>
                            <td>{{x.mobile_number}}</td>
                            <td>{{x.declined_status}}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer" style="text-align: center;">
            <button class="btn btn-success" @click="onClose()">Ok</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
    </div>
    <EditCandidate v-if="editCandidate" @editCandidate_emit="oncloseEditCandidate" :data="canData" :shwovalueEditCandidate="editCandidate"></EditCandidate>
    <reason-popup v-model="reasonOpen" :shwovalueReason="reasonOpen" v-if="reasonOpen"></reason-popup>
    <ResultShow v-model="resultOpen" :shwovalueResultResult="resultOpen" v-if="resultOpen"></ResultShow>
    <ScheduleDetails v-model="sheduleOpen" :shwovalueScheduleDetails="sheduleOpen" v-if="sheduleOpen"></ScheduleDetails>
  </div>
</template>
<script>
// import { CContainer } from '@coreui/vue'
import router from '../router/index'
import axios from 'axios'
import { BaseURL } from '../shared/classes'
// import moment from 'moment'
import Vue from 'vue'
import ScheduleDetails from '../newLayoutOrg/scheduledetail'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import * as Cookies from 'js-cookie'
import $ from 'jquery'
import EditCandidate from '../newLayoutOrg/EditCandidate.vue'
import ReasonPopup from '../newLayoutOrg/reasonpopup'
import JwPagination from 'jw-vue-pagination'
import momentsone from 'moment-timezone'
import moment from 'moment'
import ResultShow from '../newLayoutOrg/result_popup'

Vue.component('jw-pagination', JwPagination)
const timezoneList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]
const optionsOverrides1 = {
  durations: {
    global: 3000
  },
  icons: {
    enabled: false
  },
  labels: {
    success: '',
    warning: '',
    alert: ''
  },
  position: 'bottom-right'
}
export default {
  data () {
    return {
      fullPage: true,
      isLoading: false,
      postId: '',
      postsearch: '',
      postsort: 7,
      user_id: localStorage.getItem('user_id'),
      candidateListing: [],
      myCurrentDate: '',
      myPastDate: '',
      startdate: '',
      enddate: '',
      bookmarkValue: '',
      resumefiles: [],
      uploadCandidateResume: true,
      activeFilter: '',
      status: '',
      score: '',
      fromdate: '',
      todate: '',
      pages: [1, 2, 3, 4],
      minDatetime1: '',
      availability: '',
      id: '',
      editCandidate: false,
      canData: null,
      postData: null,
      infoName: '',
      reasonOpen: false,
      viewid: '',
      timezone: momentsone.tz.guess(),
      timezonetype: '',
      type: this.$route.params.type,
      userInfo: JSON.parse(localStorage.getItem('user__details')),
      scheduleId: '',
      setAvailabilityType: '',
      reasonList: [],
      reScheduleReason: '',
      reScheduleComments: '',
      selected: '',
      resultOpen: false,
      selectedSt: '',
      sit: '',
      current_date: '',
      sheduleOpen: false,
      errormsg: '',
      interviewersList: [],
      showInterviewersListModal: false,
      interviewersListErrorMsg: '',
      exampleItems: [],
      skip: 0,
      disableSetAvailabilityButton: false
    }
  },
  components: {
    EditCandidate, ReasonPopup, ResultShow, ScheduleDetails, Loading
  },
  created () {
    const currentTime = moment().tz(moment.tz.guess())
    this.timezoneApp = currentTime.format('z')
    if (this.type === '2' || this.type === 2) {
      this.typename = 'interviewer'
    } else {
      this.typename = 'candidate'
    }
    if (this.timezoneApp === 'EDT') {
      this.timezoneApp = 'EST'
    } else if (this.timezoneApp === 'PDT') {
      this.timezoneApp = 'PST'
    } else if (this.timezoneApp === 'AKDT') {
      this.timezoneApp = 'AHST'
    }
    if (this.$route.params.type === 'all') {
      this.status = ''
      this.score = ''
      this.sit = ''
      this.selectedSt = ''
    } else if (this.$route.params.type === 'scheduled') {
      this.status = 'Scheduled'
    } else if (this.$route.params.type === 'sit6') {
      this.sit = '>6'
    } else if (this.$route.params.type === 'selected') {
      this.selectedSt = 'Yes'
    }
    this.getreasondata()
    this.getPostDetails()
    this.candidateList()
    localStorage.getItem('user_id')
    localStorage.getItem('user__details')
    console.log(this.userInfo)
  },
  mounted () {
    var d = new Date()
    var day = this.addZero(d.getDate())
    var month = this.addZero(d.getMonth() + 1)
    var year = this.addZero(d.getFullYear())
    this.minDatetime1 = year + '-' + month + '-' + day
    // this.$root.$on('message_from_abc', (arg) => {
    //   this.candidateList()
    // })
  },
  methods: {
    addZero (i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    showResult (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.$route.params.id))
      localStorage.setItem('sid', JSON.stringify(id))
      this.resultOpen = true
    },
    getreasondata () {
      const config = {
        headers: {
          'content-type': 'application/json',
          Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('token'))
        }
      }
      axios.get(BaseURL + '/dashboard/get_cancel_reason/web', config).then(response => {
        this.reasonList = response.data.reasonlist
      }).catch(e => {
      })
    },
    checkingdate (date, end) {
      // var currentDate = new Date()
      // this.current_date = moment(String(currentDate)).format('YYYYMMDDHHmm')
      // var scheduledate = moment.utc(date).subtract(5, 'minutes').toDate()
      // scheduledate = moment.utc(scheduledate).format('YYYYMMDDHHmm')
      // var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      // if (this.current_date >= scheduledate && this.current_date < endtime) {
      //   return 'yes'
      // } else {
      //   return 'no'
      // }
      var currentDate = new Date()
      this.current_date = moment(String(currentDate)).utc().format('YYYYMMDDHHmm')
      var scheduledate = moment.utc(date).subtract(5, 'minutes').toDate()
      scheduledate = moment.utc(scheduledate).format('YYYYMMDDHHmm')
      var endtime = moment.utc(end).format('YYYYMMDDHHmm')
      if (this.current_date >= scheduledate && this.current_date < endtime) {
        return 'yes'
      } else {
        return 'no'
      }
    },
    selectInterviewer () {
      // router.push({ name: 'SelectInterviewer' })
      this.$router.push('/select_interviewer/' + this.$route.params.id)
    },
    // setAvailability () {
    //   router.push({ name: 'SetAvailability' })
    // },
    getPostDetails () {
      axios
        .get(BaseURL + '/dashboard/get_post_details_web/' + this.$route.params.id)
        .then(response => {
          this.postData = response.data.postInfo[0]
        })
        .catch(error => {
          console.log(error)
        })
    },
    connect (id, sid, viewid, x) {
      Cookies.set('channel', id)
      Cookies.set('sid', sid)
      Cookies.set('type', 1)
      localStorage.setItem('type', 1)
      Cookies.set('baseMode', 'avc')
      Cookies.set('transcode', 'interop')
      Cookies.set('attendeeMode', 'video')
      Cookies.set('videoProfile', '480p_4')
      localStorage.setItem('job_title', x.job_tittle)
      localStorage.setItem('organization', this.userInfo.organization)
      router.push('/agoraMod/meeting')
    },
    candidateList () {
      var status1
      if (this.status === 'Selected') {
        this.selectedSt = 'Yes'
        status1 = ''
      } else if (this.status === 'Rejected') {
        this.selectedSt = 'No'
        status1 = ''
      } else {
        status1 = this.status
      }
      const data = {
        skip: 0,
        post_id: this.$route.params.id,
        search: this.postsearch,
        status: status1,
        score: this.score,
        fromdate: this.fromdate,
        todate: this.todate,
        sit: this.sit,
        selected: this.selectedSt
      }
      axios
        .post(BaseURL + '/dashboard/get_upload_candidate', { formData: data })
        .then(response => {
          this.candidateListing = response.data.candidate_list
          // this.post_id = response.data.interviewerList
          console.log(this.candidateListing)
          // this.exampleItems = [...Array(response.data.post_list_total_count).keys()].map(i => (i))
          this.exampleItems = [...Array(response.data.candidate_list_total).keys()].map(i => (i))
          console.log('this.exampleItems', this.exampleItems)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDatas () {
      var status1
      if (this.status === 'Selected') {
        this.selectedSt = 'Yes'
        status1 = ''
      } else if (this.status === 'Rejected') {
        this.selectedSt = 'No'
        status1 = ''
      } else {
        status1 = this.status
      }
      const data = {
        skip: this.skip,
        post_id: this.$route.params.id,
        search: this.postsearch,
        status: status1,
        score: this.score,
        fromdate: this.fromdate,
        todate: this.todate,
        sit: this.sit,
        selected: this.selectedSt
      }
      axios
        .post(BaseURL + '/dashboard/get_upload_candidate', { formData: data })
        .then(response => {
          this.candidateListing = response.data.candidate_list
        })
        .catch(error => {
          console.log(error)
        })
    },
    onChangePage (pageOfItems) {
      console.log('pageOfItems', pageOfItems)
      this.skip = pageOfItems[0]
      this.getDatas()
    },
    fileUpload1 (e) {
      this.resumefiles = []
      console.log('check file ', e.target)
      $('.custom-file-upload').removeClass('is-invalid')
      for (let k = 0; k < e.target.files.length; k++) {
        if (
          e.target.files[k].type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
          e.target.files[k].type === 'application/pdf'
        ) {
          if (e.target.files[k].size < '3000001') {
            this.resumefiles.push(e.target.files[k])
          } else {
            this.errormsg = 'Please upload the file with size <3 MB'
          }
        } else {
          this.errormsg = 'Please upload only pdf or doc format'
        }
      }
      $('#file1').val('')
      console.log('resumefiles', this.resumefiles)
    },
    removeUploading (index) {
      this.resumefiles.splice(index, 1)
      console.log(this.resumefiles)
    },
    cancelUploading () {
      this.resumefiles = []
      this.uploadCandidateResume = false
    },
    clearFilter () {
      this.status = ''
      this.score = ''
      this.fromdate = ''
      this.todate = ''
      this.sit = ''
      this.selectedSt = ''
      this.candidateList()
    },
    viewFeedback (id) {
      // router.push({ name: 'newFeedback' })
      var routerPage = router.resolve('/viewfeedback_org/' + id)
      window.open(routerPage.href, '_blank')
    },
    editCandidateFn (data) {
      this.canData = data
      this.editCandidate = true
    },
    oncloseEditCandidate (val) {
      this.editCandidate = val.close
      if (val.reload === true) {
        this.skip = 0
        // this.candidateList()
        this.getDatas()
      }
    },
    openInfo (x) {
      if (x.interviewer_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.user_first_name + ' ' + x.user_last_name
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.interviewer_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.user_first_name + ' ' + x.user_last_name
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.candidate_accept === 'yes' && x.status === 'Accepted') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has accepted the schedule'
      } else if (x.candidate_cancel === 'yes' && x.status === 'Declined') {
        this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = this.infoName + ' has declined the schedule'
      } else if (x.status === 'Auto-Declined') {
        // this.infoName = x.candidate_name + ' ' + x.candidate_lastname
        this.infoName = 'Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.'
      }
      $('#myModal1').modal('show')
    },
    closeViolated () {
      $('#myModal1').modal('hide')
    },
    selectModal (_id, select) {
      this.scheduleId = _id
      this.selected = select
      $('#selectModalShow').modal('show')
    },
    selectCandidate () {
      this.mainurl = '/dashboard/update_candidate_selected'
      var formData = {
        _id: this.scheduleId,
        candidate_selected: this.selected
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        $('#selectModalShow').modal('hide')
        this.$awn.success(response.data.message)
        this.candidateList()
      }).catch(e => {
        console.log(e)
      })
    },
    setAvailabilityDataSet (data, type = 'schedule') {
      this.scheduleId = data._id
      this.postId = data.post_id
      this.setAvailabilityType = type
    },
    setSchedule (data) {
      this.scheduleId = data._id
      this.postId = data.post_id
      var scheduleDate = moment(data.start_datetime).utc().format('yyyy-MM-DD')
      var scheduleStartTime = moment(data.start_datetime).utc().format('HH:mm:ss')
      var scheduleEndTime = moment(data.start_datetime).utc().add(1, 'hours').format('HH:mm:ss')
      var startDatetime = moment(data.start_datetime).utc().format('yyyy-MM-DD HH:mm:ss')
      var endDatetime = moment(data.start_datetime).utc().add(1, 'hours').format('yyyy-MM-DD HH:mm:ss')
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === this.timezone) {
          this.timezonetype = timezoneList[i].name
        }
      }
      var formData = {}
      this.mainurl = '/dashboard/add_schedule_availability'
      formData = {
        post_id: this.postId,
        schedule_id: this.scheduleId,
        schedule_date: scheduleDate,
        schedule_end_time: scheduleEndTime,
        schedule_start_time: scheduleStartTime,
        start_datetime: startDatetime,
        end_datetime: endDatetime,
        schedule_org_timezone: this.timezonetype,
        schedule_candidate_timezone: '',
        schedule_timezone: this.timezonetype
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        if (response.data.message === 'success') {
          this.$awn.success('Success ')
        } else if (response.data.message === 'already scheduled') {
          this.$awn.alert('The selected Panels are already blocked for the same timing. Please choose different panels', optionsOverrides1)
        } else {
          this.$awn.success(response.data.message)
        }
        this.candidateList()
      }).catch(e => {
        console.log(e)
      })
    },
    setAvailability () {
      this.disableSetAvailabilityButton = true
      if (this.availability === '') {
        this.$awn.alert('Select Date ', optionsOverrides1)
        return
      }
      if (this.setAvailabilityType === 'reschedule' && this.reScheduleReason === '') {
        this.$awn.alert('Select Reason ', optionsOverrides1)
        return
      }
      var scheduleDate = moment(this.availability).format('yyyy-MM-DD')
      var scheduleStartTime = moment(this.availability).format('HH:mm:ss')
      var scheduleEndTime = moment(this.availability).add(1, 'hours').format('HH:mm:ss')
      var startDatetime = moment(this.availability).format('yyyy-MM-DD HH:mm:ss')
      var endDatetime = moment(this.availability).add(1, 'hours').format('yyyy-MM-DD HH:mm:ss')
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === this.timezone) {
          this.timezonetype = timezoneList[i].name
        }
      }
      var formData = {}
      if (this.setAvailabilityType === 'schedule') {
        this.mainurl = '/dashboard/add_schedule_availability'
        formData = {
          post_id: this.postId,
          schedule_id: this.scheduleId,
          schedule_date: scheduleDate,
          schedule_end_time: scheduleEndTime,
          schedule_start_time: scheduleStartTime,
          start_datetime: startDatetime,
          end_datetime: endDatetime,
          schedule_org_timezone: this.timezonetype,
          schedule_candidate_timezone: this.timezonetype,
          schedule_timezone: this.timezonetype
        }
      } else if (this.setAvailabilityType === 'reschedule') {
        this.mainurl = '/dashboard/reschedule_newreq'
        formData = {
          _id: this.scheduleId,
          schedule_date: scheduleDate,
          schedule_end_time: scheduleEndTime,
          schedule_start_time: scheduleStartTime,
          start_datetime: startDatetime,
          end_datetime: endDatetime,
          reschedule_reason_id: this.reScheduleReason._id,
          reschedule_reason_name: this.reScheduleReason.value,
          reschedule_reason_comments: this.reScheduleComments
        }
      }
      axios.post(BaseURL + this.mainurl, {
        formData: formData
      }, this.config).then(response => {
        $('#setAvailability').modal('hide')
        this.disableSetAvailabilityButton = false
        if (response.data.message === 'success') {
          this.$awn.success('Success ')
        } else {
          this.$awn.success(response.data.message)
        }
        this.candidateList()
      }).catch(e => {
        this.disableSetAvailabilityButton = false
        console.log(e)
      })
    },
    showReason1 (id, sid, type, re = '') {
      this.viewid = id
      if (type === 2) {
        localStorage.setItem('reschedule', JSON.stringify('decline'))
      } else if (type === 3) {
        localStorage.setItem('reschedule', JSON.stringify('decline1'))
      } else if (re === 're') {
        localStorage.setItem('reschedule', JSON.stringify('cancelResch'))
      } else {
        localStorage.setItem('reschedule', JSON.stringify('cancelOrg'))
      }
      localStorage.setItem('sid', JSON.stringify(sid))
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.$route.params.id))
      this.reasonOpen = true
    },
    UploadCandidateResume (k) {
      this.uploadCandidateResume = true
      this.user_id = localStorage.getItem('_id')
      console.log('timezonelist', timezoneList)
      this.isLoading = true
      for (let i = 0; i < timezoneList.length; i++) {
        if (timezoneList[i].fullName === this.timezone) {
          this.timezonetype = timezoneList[i].name
        }
      }
      console.log(this.resumefiles)
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      const formData = new FormData()
      for (let k = 0; k < this.resumefiles.length; k++) {
        formData.append('image', this.resumefiles[k])
      }
      // formData.append('post_id', this.$route.params.id)
      // formData.append('org_id', this.userInfo._id)
      // formData.append('schedule_org_timezone', this.timezonetype)
      // formData.append('schedule_timezone', this.timezonetype)
      // console.log('formData ', formData)
      // console.log('formData.post_id ', formData.post_id)
      axios.post(BaseURL + '/dashboard/upload_candidate/' + this.$route.params.id + '/' + this.userInfo._id + '/' + this.timezonetype + '/' + this.timezonetype, formData, config)
        .then(response => {
          this.resumeResponse = response.data.message
          this.$awn.success('Candidate Resume uploaded successfully ')
          $('#uploadResume').modal('hide')
          this.candidateList()
          this.isLoading = false
        }, config)
        .catch(e => {
          console.log(e)
        })
    },
    showShedule1 (id, userid) {
      this.viewid = userid
      localStorage.setItem('viewid', JSON.stringify(this.viewid))
      localStorage.setItem('postId', JSON.stringify(this.$route.params.id))
      localStorage.setItem('sid', JSON.stringify(id))
      this.sheduleOpen = true
    },
    getTime (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('hh:mm a')
      return Start
    },
    getDate (date) {
      const Start = momentsone.utc(date).tz(this.timezone).format('DD MMM yyyy')
      return Start
    },
    showPanels (id) {
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }
      axios.get(BaseURL + '/dashboard/get_schedule_interviewers_list/' + id, config)
        .then(response => {
          console.log('response', response.data.message)
          this.interviewersListErrorMsg = ''
          this.interviewersList = response.data.interviewers_list
          if (this.interviewersList.length === 0) {
            this.interviewersListErrorMsg = 'The selected Panels are already blocked for the same timing. Please choose different panels'
          }
          this.showInterviewersListModal = true
        }, config)
        .catch(e => {
          console.log(e)
        })
    },
    onClose () {
      this.showInterviewersListModal = false
    }
    // viewFeedback (data) {
    //   this.id = data._id
    //   this.orgName = data.organization
    //   this.orgEmail = data.user_email
    //   var email = this.orgEmail
    //   var sp = email.split('@')
    //   let routerPage = ''
    //   if (sp[1] === 'acsicorp.com') {
    //     routerPage = this.$router.resolve('/new_Feedback/' + this.id)
    //   } else {
    //     routerPage = this.$router.resolve('/viewfeedbackcommon/' + this.id)
    //   }
    //   window.open(routerPage.href, '_blank')
    // }
    // submitFeedback (data) {
    //   this.id = data._id
    //   this.orgName = data.organization
    //   this.orgEmail = data.user_email
    //   var email = this.orgEmail
    //   var sp = email.split('@')
    //   let routerPage = ''
    //   if (sp[1] === 'acsicorp.com') {
    //     routerPage = this.$router.resolve('/addfeedback/' + this.id)
    //   } else {
    //     routerPage = this.$router.resolve('/addfeedbackcommon/' + this.id)
    //   }
    //   window.open(routerPage.href, '_blank')
    // }
  }
}
</script>

<style lang="scss" scoped>
.postArea {
  background: #f5f5f5;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  padding: 10px;
  //   border: solid 2px #80808030;
  border-radius: 5px;
}
.postArea1 {
  background: #f5f5f5;
  width: 100%;
  display: grid;
  grid-template-columns: 30% 39% 30%;
  align-items: center;
}
.warningBorder {
  border: #fad475;
  border-width: 1px;
  border-style: solid;
  box-shadow: 1px 1px 3px 0.2px #fad475;
}
.dangerBorder {
  border: rgb(255, 0, 0);
  border-width: 1px;
  border-style: solid;
  box-shadow: 1px 1px 3px 0.2px rgb(248, 140, 94);
}
.maincontent {
  margin: 10px 4% 4%;
  background-color: white;
  padding: 10px;
  min-height: 450px;
}
.myIcons {
  padding-top: 5px;
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  // display: flex;
  // flex-direction: row;
  justify-content: flex-end;
}
.icon1 {
  grid-column: 5/6;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.icon2 {
  grid-column: 6/7;
  padding: 10px;
  text-align: center;
  cursor: pointer;
}
.icon1 > .fa-user-o {
  font-size: 25px;
  color: #5bad2b;
}
.icon2 > .fa-cloud-upload {
  font-size: 25px;
  color: #5bad2b;
}
.iconName {
  font: 10px;
  color: black;
}
.round {
  width: 70px;
  height: 70px;
  // border: 1px solid #5bad2b;
  border-radius: 50%;
  padding: 7px;
}
.uniqueId {
  display: flex;
  text-align: start;
}
.validity {
  // align-content: right;
  text-align: end;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
}
.position {
  display: flex;
  text-align: start;
  flex-direction: column;
}
.candidateArea {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.canName {
  font-size: 18px;
  font-weight: bold;
}
.candidateDetails {
  text-align: start;
}
.availability1 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  row-gap: 6px;
}
.countStyle {
  font-size: 2.5rem !important;
}
.countSpecificationStyle {
  font-size: 1.3rem !important;
}
a {
  color: #333;
}
.modalClose {
  display: flex;
  justify-content: center;
}
.AvailabilityPopup {
  width: 60%;
  // height: 200px;
}
.filterTopclass {
  list-style: none;
  // margin: 10px;
  display: flex;
  flex-direction: column;
  row-gap: 2px;
}
.filterListclass {
  padding: 4px 10px 0px 10px;
  // border-bottom: 0.5px solid rgb(249, 248, 248);
}
// .filterListclass:hover {
//   // color: #5bad2b;
//   // background-color: rgb(246, 243, 243);
// }
.activeFilterclass {
  background-color: #5bad2b;
}
.activeFilterclass:hover {
  background-color: #5bad2b;
}
.activeFiltertext {
  color: white;
}
.filterDivclass {
  background-color: white;
  padding: 10px;
}
.profileClass {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}
.statusName {
  font-size: 1.6rem !important;
  font-weight: 600;
}
div.searchinput input[type="text"] {
  padding: 10px;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  float: left;
  width: 300px;
  background: white;
  outline: none;
}

div.searchinput button {
  float: left;
  width: 50px;
  padding: 10px;
  background: #5bad2b;
  color: white;
  font-size: 14px;
  border: 1px solid rgb(217, 215, 215);
  border-left: none;
  cursor: pointer;
}

div.searchinput button:hover {
  background: green;
}

div.searchinput::after {
  content: "";
  clear: both;
  display: table;
}
.filterdata {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: 10px;
}
.postArea:hover {
  border-left: #5bad2b;
}
.filterBoxBorder {
  border: 1px solid rgb(237, 234, 234);
  background-color: #f5f5f5;
  padding-bottom: 8px;
}
.filterbyClass {
  background-color: #f5f5f5;
}
.btncolorClass {
  color: #5bad2b;
}
.badge {
  position: relative;
  top: -18px;
  left: -5px;
  // border: 0.4px solid black;
  border-radius: 50%;
  background-color: white;
  color: black;
  font-size: 14px;
  padding: 1px;
}
.fw-600 {
  font-weight: 600;
}
.resume{
  width: 100px;
  height: 100px;
}
.Orgimage1 {
  border-radius: 50%;
}
.buttonStyle {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  column-gap: 7px;
}
.paginationClass {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.pagination {
  border-radius: 0px !important;
}
.active a.page-link {
  background-color: #5bad2b;
  border-color: #5bad2b;
}
.active a.page-link:hover {
  background-color: #5bad2b;
  border-color: #5bad2b;
}
// .countcard{
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   align-content:center ;
//   width: 100px;
//   height: 100px;
//   color: #5bad2b;
//   // background-color: white;
// }
</style>
